"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePage = exports.validateField = exports.apiUISettingV2Schema = void 0;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var yup = _interopRequireWildcard(require("yup"));
var _types = require("./types");
var apiUISettingFieldBaseSchema = {
  id: yup.string().required(),
  displayName: yup.string(),
  mandatory: yup.boolean(),
  editable: yup.boolean(),
  visible: yup.boolean(),
  rules: yup.array(yup.object()),
  level: yup.number(),
  maxCharacters: yup.number(),
  helpText: yup.string()
};
var apiUISettingFieldSchema = yup.object().shape((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiUISettingFieldBaseSchema), {}, {
  subFields: yup.array(yup.object().shape(apiUISettingFieldBaseSchema))
}));
var apiUISettingPageBaseSchema = {
  id: yup.string().required(),
  fields: yup.array().of(apiUISettingFieldSchema),
  displayName: yup.string(),
  hiddenFields: yup.array().of(yup.string())
};
var apiUISettingPageSchema = yup.object().shape((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiUISettingPageBaseSchema), {}, {
  subPages: yup.array().of(yup.object().shape(apiUISettingPageBaseSchema))
}));
var apiUISettingV2Schema = yup.object().shape({
  customer: yup.string().required(),
  lastUpdate: yup.string().required(),
  homePage: yup.string(),
  fieldDefinitions: yup.array().of(apiUISettingFieldSchema),
  pages: yup.array().of(apiUISettingPageSchema).required()
});
exports.apiUISettingV2Schema = apiUISettingV2Schema;
var validateField = function validateField(field) {
  if (!field.displayName) {
    throw new _types.UISettingsError("Field ".concat(field.id, " doesn't have a displayName"));
  }
};
exports.validateField = validateField;
var validatePage = function validatePage(page) {
  if (!page.displayName) {
    throw new _types.UISettingsError("Page ".concat(page.id, " doesn't have a displayName"));
  }
};
exports.validatePage = validatePage;